/* eslint-disable multiline-ternary */
import { Drawer } from '@mui/material'
import React, { useState } from 'react'
import { useAlert, useGroup, usePromiseEvent } from '../../hooks'
import { CONSUMER, FREE } from '../../services/cognito/userGroups'
import Onboarding from './onboarding'
import LPQuestionnaire from './lpq/'
import makeStyles from '@mui/styles/makeStyles'
import { useDispatch } from 'react-redux'
import { userSlice } from '../../reducers'
import {
  PersonaliseAlert,
  CustomiseAlert,
  UpdatingModal
} from './lpq/components'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'space-between',
    '& .MuiDrawer-paper': {
      maxWidth: 425,
      width: '100%'
    }
  }
}))

const UserPreferences = ({ profile }) => {
  const { isInGroup } = useGroup()
  const dispatch = useDispatch()
  const updateProfile = usePromiseEvent('updateProfile')
  const { enqueueAlert, enqueueMsg } = useAlert()

  const allPhases = isInGroup([FREE, CONSUMER])
    ? ['onboarding', 'lpq']
    : ['onboarding']

  const [phase, setPhase] = useState(allPhases[0])
  const [open, setOpen] = useState(true)
  const [saving, setSaving] = useState(false)
  const [partialProfile, setPartialProfile] = useState()

  const classes = useStyles()

  const saveProfile = async (partial, type = 'create', from) => {
    const response = await updateProfile({
      partial: {
        ...partialProfile,
        ...partial,
        onboarded: true
      },
      type,
      ...(from && { from })
    })
    dispatch(userSlice.actions.setProfile(response))
  }

  const handleFinishOnboarding = partial => {
    const isLastPhase = () => allPhases.length === 1

    const saveOnboarding = async () => {
      try {
        setSaving(true)
        setOpen(false)
        await saveProfile(partial)
        enqueueAlert(<PersonaliseAlert />)
      } catch (err) {
        enqueueMsg('Unable to update the user profile', 'error')
      } finally {
        setSaving(false)
      }
    }

    if (isLastPhase()) {
      saveOnboarding()
    } else {
      setPartialProfile(partial)
      setPhase(allPhases[1])
    }
  }

  const handleFinishLpq = async partial => {
    try {
      setOpen(false)
      setSaving(true)
      await saveProfile(partial)
      enqueueAlert(<PersonaliseAlert />)
    } catch (err) {
      enqueueMsg('Unable to update the user profile', 'error')
    } finally {
      setSaving(false)
    }
  }

  const handleClose = async from => {
    try {
      setOpen(false)
      enqueueAlert(<CustomiseAlert />)
      await saveProfile({}, 'cancel', from)
    } catch (err) {
      enqueueMsg('Unable to update the user profile', 'error')
    }
  }

  return (
    <>
      <Drawer
        onClose={() => handleClose('outside-click')}
        open={open}
        className={classes.root}
        anchor='right'
      >
        {phase === 'onboarding' ? (
          <Onboarding
            profile={profile}
            onClose={handleClose}
            onFinish={handleFinishOnboarding}
            hasNextPhase={allPhases.length > 1}
          />
        ) : (
          <LPQuestionnaire onClose={handleClose} onFinish={handleFinishLpq} />
        )}
      </Drawer>
      {saving && <UpdatingModal open={saving} />}
    </>
  )
}

export default UserPreferences
